module.exports = __webpack_public_path__ + "static/media/upload.195061b7.svg";